"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initYandexMetrics = exports.initSravniTM = exports.initGTM = exports.defineDataLayer = void 0;
var _helpers = require("./helpers");
var _parseMainLocationUrl = require("./parseMainLocationUrl");
/**
 * Initialize analytic scripts
 * @param {IGTMOptions} options
 * @example
 *
 * ```jsx
 * <script dangerouslySetInnerHTML={{ __html: initGTM({ ab: 'AB_HOME', userId: subId, }) }} />
 * ```
 */

var initGTM = function initGTM(options) {
  var _options$id = options.id,
    id = _options$id === void 0 ? "GTM-PMDFG9" : _options$id,
    userId = options.userId,
    theme = options.theme,
    pushOptions = options.push,
    isWebview = options.isWebview,
    fullURL = options.fullURL,
    wl = options.wl,
    abTestingStatistics = options.abTestingStatistics;
  var toPush = [{
    isWebview: !!isWebview
  }];
  if (userId) {
    toPush.push({
      SravniUserId: userId
    });
  }
  if (theme) {
    toPush.push({
      theme
    });
  }
  if (pushOptions && Array.isArray(pushOptions)) {
    toPush.push.apply(toPush, pushOptions);
  }
  if (fullURL && !wl) {
    toPush.push({
      fullURL
    });
    var parsedMainLocation = (0, _parseMainLocationUrl.parseMainLocation)(fullURL);
    if (parsedMainLocation) {
      toPush.push({
        mainLocation: parsedMainLocation
      });
    }
  }
  if (wl) {
    var wlLocation = wl.wlLocation,
      partnerLocation = wl.partnerLocation,
      _fullURL = wl.fullURL;
    toPush.push({
      wlLocation
    }, {
      partnerLocation
    }, {
      fullURL: _fullURL
    });
  }
  if (abTestingStatistics) {
    toPush.push({
      abTestingStatistics: abTestingStatistics.statistics
    });
    toPush.push({
      analyticsId: abTestingStatistics.userId
    });
  }
  var response = ["window.dataLayer = window.dataLayer || [];"].concat(toPush.map(function (item) {
    return "window.dataLayer.push(" + JSON.stringify(item) + ");";
  }), [(0, _helpers.getGtmCode)(id)]);
  return response.join("");
};

/**
 * Initialize analytic scripts
 * @param {IYandexMetricsOptions} options
 * @example
 *
 * ```jsx
 * <script dangerouslySetInnerHTML={{ __html: initYandexMetrics({ ab: 'AB_HOME', userId: subId, }) }} />
 * ```
 */
exports.initGTM = initGTM;
var initYandexMetrics = function initYandexMetrics(options, dataLayer) {
  var id = options.id,
    wl = options.wl,
    abTestingStatistics = options.abTestingStatistics,
    pushOptions = options.push,
    isWebview = options.isWebview,
    userId = options.userId,
    theme = options.theme,
    webvisor = options.webvisor,
    childIframe = options.childIframe,
    defer = options.defer;
  var toPush = [{
    isWebview: !!isWebview
  }];
  if (userId) {
    toPush.push({
      SravniUserId: userId
    });
  }
  if (theme) {
    toPush.push({
      theme
    });
  }
  if (pushOptions && Array.isArray(pushOptions)) {
    toPush.push.apply(toPush, pushOptions);
  }
  if (wl) {
    var wlLocation = wl.wlLocation,
      partnerLocation = wl.partnerLocation,
      fullURL = wl.fullURL;
    toPush.push({
      wlLocation
    }, {
      partnerLocation
    }, {
      fullURL
    });
  }
  if (abTestingStatistics) {
    toPush.push({
      abTestingStatistics: abTestingStatistics.statistics
    });
    toPush.push({
      analyticsId: abTestingStatistics.userId
    });
  }
  var response = [(0, _helpers.defineIsTurboApp)(dataLayer)].concat(toPush.map(function (item) {
    return "window['" + dataLayer + "'].push(" + JSON.stringify(item) + ");";
  }), [(0, _helpers.getYandexMetricsCode)({
    id,
    webvisor,
    childIframe,
    defer
  })]);
  return response.join("");
};

/**
 * Initialize analytic scripts
 * @param {ISravniTMOptions} options
 * @example
 *
 * ```jsx
 * <script dangerouslySetInnerHTML={{ __html: initSravniTM({ ab: 'AB_HOME', userId: subId, }) }} />
 * ```
 */
exports.initYandexMetrics = initYandexMetrics;
var initSravniTM = function initSravniTM(options) {
  var gtmOptions = (0, _helpers.getGtmOptionsFromSravniTMOptions)(options);
  var yandexMetricsOptions = (0, _helpers.getYandexMetricsOptionsFromSravniTMOptions)(options);
  var dataLayer = "sravniDataLayer";
  var googleDataLayer = "dataLayer";
  var response = ["window['" + dataLayer + "'] = window['" + dataLayer + "'] || [];", "window['" + googleDataLayer + "'] = window['" + googleDataLayer + "'] || [];", (0, _helpers.defineSravniTM)({
    dataLayer,
    googleDataLayer,
    yandexId: yandexMetricsOptions.id
  }), initGTM(gtmOptions), (0, _helpers.defineGoogleClientId)(dataLayer), initYandexMetrics(yandexMetricsOptions, dataLayer)];
  return response.join("");
};

/**
 * @deprecated
 */
exports.initSravniTM = initSravniTM;
var defineDataLayer = _helpers.defineABVariant;
exports.defineDataLayer = defineDataLayer;